<template>
  <div id="app">
    <div id="preloader" v-show="isLoading">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->

    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },
  created() {
    window.addEventListener("scroll", this.scrolling);
  },
  methods: {
    scrolling() {
      let classesToAdd = ["animated", "slideInDown", "fixed"];
      let header = document.querySelector(".header");
      if (window.scrollY > 1) {
        this.stickNav = true;
        header.classList.add(...classesToAdd);
      } else {
        this.stickNav = false;
        header.classList.remove(...classesToAdd);
      }
    },
  },
};
</script>
